Accounts = require 'common/lib/accounts'
Auth = require 'db/auth'
ChangeAvatarPopoverView = require 'views/member/change-avatar-popover-view'
Format = require 'lib/markdown/format'
localizeServerError = require 'lib/localize-server-error'
PopOver = require 'views/lib/pop-over'
TabbedPaneView = require 'views/internal/tabbed-pane-view'
Util = require 'lib/util'
View = require 'view'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'
xtend = require 'xtend'
memberDetailTemplate = require 'views/templates/member_detail'
ClientConfig = require 'debug/client-config'

module.exports = class MemberView extends View
  mixin TabbedPaneView, @

  initialize: ->
    @listenTo @model, 'change:initials change:avatarHash change:avatarSource change:fullName change:username change:bio change:prefs change:paidAccount', @render
    @listenTo @model, 'change:initials change:fullName change:username change:bio', @renderDetails
    return

  events:
    'click .js-change-avatar-profile': 'changeAvInProfile'
    'click .js-edit-profile': 'editProfile'
    'click .js-submit-profile': 'submitProfile'
    'submit .js-profile-form': 'submitProfile'
    'click .js-cancel-edit-profile': 'cancelEditProfile'

    'click .tabbed-pane-nav-item-button:not(.active)': 'switchSection'

  delegateEvents: (events) ->
    super(xtend(MemberView::events, events || @events))

  render: ->
    isMe = Auth.isMe(@model)

    data = @model.toJSON()
    if @model.organizationList.models.length > 0
      data.showOrgs = true

    if isMe
      standing = data.paidAccount?.standing
      data.hasAccount = @model.hasMemberOrOrgAccount()
      data.accountProblem = Accounts.isProblem(standing)
      data.isMe = true
      data.upsellEnabled = !ClientConfig.get('dontUpsell')

    data.hasCrown = @model.isFeatureEnabled('crown')
    data.editable = isMe

    @$el.html memberDetailTemplate(data)

    @renderDetails()

    @renderMainContent()

    @

  renderDetails: ->
    isMe = Auth.isMe(@model)

    data = @model.toJSON()
    data.bioHtml = Format.markdownAsHtml(data.bio, { textData: data.bioData })
    data.hasCrown = @model.isFeatureEnabled('crown')

    @$('.js-current-details').empty().append(
      templates.fill(
        'member_detail_profile_info',
        data,
        { editable: isMe }
      )
    )

    if isMe
      @$('.js-profile-form').empty().append(
        templates.fill(
          'member_detail_profile_edit',
          data,
          { editable: isMe }
        )
      )

    @

  setActiveView: (sClass) ->
    @$('.tabbed-pane-nav-item-button').removeClass('active')
    @$(sClass).addClass('active')
    return

  changeAvInProfile: (e) ->
    Util.stop(e)
    track("Member View", "Header", "Change Avatar Menu")

    PopOver.toggle
      elem: @$('.js-change-avatar-profile')
      view: new ChangeAvatarPopoverView({ @model, @modelCache })

    return

  editProfile: (e) ->
    Util.stop(e)

    @$('.js-current-details').addClass('hide')
    @$('.js-profile-form').removeClass('hide')

    track("Member View", "Click Edit Profile")
    return

  cancelEditProfile: (e) ->
    Util.stop(e)
    @$('.js-current-details').removeClass('hide')
    @$('.js-profile-form').addClass('hide')
    @$('.js-profile-form')[0].reset()
    return

  submitProfile: (e) ->
    Util.stop(e)

    # we're probably waiting on the server after submission. just a sec.
    return if @disabled

    data = {}
    for field in ['fullName', 'username', 'bio', 'initials']
      data[field] = @$(".js-profile-form [name=#{field}]").val()

    data.initials = data.initials.toUpperCase()

    # disable submitting while we wait for the server.
    @disableSubmit()

    @model.update data, waitForServer: true, (err) =>

      # okay, re-enable submit
      @disabled = false
      @$('.js-submit-profile').removeAttr('disabled')

      if err
        trimmedErrorMsg = err.message.trim().toLowerCase()
        @$('.js-profile-form-error')
          .removeClass('hide')
          .text(localizeServerError(trimmedErrorMsg))
      else
        @$('.js-profile-form-error').addClass('hide')
        @cancelEditProfile()
        track("Member", "Successfully Change User Info")
      return

    return

  disableSubmit: ->
    @disabled = true
    @$('.js-submit-profile').attr('disabled', 'disabled')
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-view.coffee